import { useTranslation } from "react-i18next";
import { ButtonWithLoadingState } from "../../../../../common/components/button-with-loading-state/ButtonWithLoadingState";
import { ShieldCheckIcon } from "../../../../../assets/icons";
import CustomerPageLayout from "../../../customer-page-layout/CustomerPageLayout";
import Can from "../../../../../guards/Can";
import { CustomerPermissions } from "../../../../../model/permissions/permissions";
import styles from "./EnergyProfileNinChoice.module.scss";

interface Props {
	onSkip: () => void;
	onVerify: () => void;
}

export const EnergyProfileNinChoice = ({ onSkip, onVerify }: Props) => {
	const { t } = useTranslation();
	return (
		<CustomerPageLayout title={t("energyManagement.ninVerificationTitle")} contentMaxWidth={600} decreaseMainContentPadding>
			<div className={styles.content}>
				<ShieldCheckIcon className={styles.icon} />
				<h2 className={styles.title}>{t("energyManagement.energyProfile.ninChoiceQuestion")}</h2>
				<p className={styles.description}>
					{t("account.web.ninChoiceDescription")}
				</p>
			</div>

			<div className={styles.buttonsRow}>
				<ButtonWithLoadingState buttonText={t("auth.skipForNow")} buttonPressed={onSkip} isSecondary style={{ flex: 1 }} />
				<Can permission={CustomerPermissions.UpdateEnergyAccountNin}>
					<ButtonWithLoadingState buttonText={t("energyManagement.energyProfile.verifyNinNow")} buttonPressed={onVerify} style={{ flex: 1 }} />
				</Can>
			</div>
		</CustomerPageLayout>
	);
};
